import { useState } from 'react';
import './Design/background';
import Todobox from './component/ToDo';
import Donebox from './component/Done';
import InputForm from './component/Inputform';
import { Container, InputBox } from './Design/BoxDesign';

function App() {
  const [toDoList, setToDoList] = useState<string[]>([]);
  const [doneToDoList, setDoneToDoList] = useState<string[]>([]);

  return (
    <>
      <Container>
        <h2>❗투두리스트❗</h2>
        <InputBox>
          <InputForm toDoList={toDoList} setToDoList={setToDoList} />
        </InputBox>
        <Todobox
          type="Todo"
          setDoneToDoList={setDoneToDoList}
          ItemList={toDoList}
          setToDoList={setToDoList}
        />
        <Donebox
          type="Done"
          setDoneToDoList={setDoneToDoList}
          ItemList={doneToDoList}
          setToDoList={setToDoList}
        />
      </Container>
    </>
  );
}

export default App;
